<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

  <app-dashboard-navbar></app-dashboard-navbar>

  <!-- Breadcrumb Area -->
  <!-- <div class="send-email-checker2"> -->
  <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
    <h1>{{Content.title}}</h1>
    <ol class="breadcrumb">
      <li class="item"><a routerLink="/">Home</a></li>
      <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
      <li class="item">{{Content.title}}</li>
    </ol>
  </div>
  <!-- </div> -->
  <!-- End Breadcrumb Area -->

  <!-- Start -->
  <div class="card">
    <p-table #dt2 [value]="jdedata" *ngIf="userroleName.roleName !== 'Supplier'" class="jde_table" dataKey="supplierId"
      [rows]="10" responsiveLayout="scroll" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]"
      [paginator]="true" s currentPageReportTemplate="Showing {first} to
            {last} of {totalRecords} entries" [filterDelay]="0" [globalFilterFields]="['orderCo','orderNumber','orderType','lineNumber','orderSuffix',
            'businessUnit' , 'addressNumber','shipToName','billToName','orderLineStatus']">
      <ng-template pTemplate="caption">
        <span class="p-input-icon-left d-flex align-items-center">
          <i class="pi pi-search"></i>
          <input pInputText class="no-style" type="text" (input)="dt2.filterGlobal($event.target.value,
                        'contains')" placeholder="Global Search" [(ngModel)]="filterval" />
          <p-button type="button" class="ml-2" (click)="reset(dt2)" icon="bx bx-reset"></p-button>
          <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onXLSExport()"
            class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom" style="margin-left: 8px;"></button>

          <div class="add-listings-btn"
            *ngIf="userroleName.roleName == 'Supplier'||userroleName.roleName =='Admin' ||userroleName.checker1 == true">

            <button type="submit" class="submit_btn" (click)="sendSelectedData()">
              Generate ASN
            </button>
          </div>
        </span>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>S.No.</th>
          <th><input type="checkbox" [(ngModel)]="isAllSelected" (change)="selectAll($event)" style="cursor: pointer;">
          </th>
          <th pSortableColumn="orderCo">Order Co <p-sortIcon field="orderCo"></p-sortIcon></th>

          <th pSortableColumn="orderNumber">
            Order No <p-sortIcon field="orderNumber"></p-sortIcon>
          </th>

          <th>Order Type</th>
          <th>Order Suffix</th>
          <th>Line Number</th>

          <th pSortableColumn="businessUnit">
            Business Unit <p-sortIcon field="businessUnit"></p-sortIcon>
          </th>

          <th pSortableColumn="addressNumber">
            Address Number <p-sortIcon field="addressNumber"></p-sortIcon>
          </th>

          <th>Bill To Name</th>

          <th pSortableColumn="shipToNumber">
            Ship To Number <p-sortIcon field="shipToNumber"></p-sortIcon>
          </th>

          <th>Ship to </th>
          <th pSortableColumn="orderDate">Order Date <p-sortIcon field="orderDate"></p-sortIcon></th>
          <th pSortableColumn="requestedDate">Req Date <p-sortIcon field="requestedDate"></p-sortIcon></th>
          <th pSortableColumn="promisedDeliveryDate">Del Date <p-sortIcon field="promisedDeliveryDate"></p-sortIcon>
          </th>
          <th pSortableColumn="shortItemNo">Short Item Number <p-sortIcon field="shortItemNo"></p-sortIcon></th>
          <th pSortableColumn="itemNumber">Item <p-sortIcon field="itemNumber"></p-sortIcon></th>
          <th>Item Desc</th>
          <th>Item Desc</th>
          <th>Line Type</th>
          <th>Next Status</th>
          <th>Next Status Desc</th>
          <th>Last Status</th>
          <th>Last Status Desc</th>
          <th>Value Stream</th>
          <th>Value Stream Desc</th>
          <th>Value Stream 1</th>
          <th>Value Stream 2</th>
          <th>UOM</th>
          <th pSortableColumn="quantityOrdered">
            Qty Ordered <p-sortIcon field="quantityOrdered"></p-sortIcon>
          </th>
          <th pSortableColumn="extPrice">
            Extended Price <p-sortIcon field="extPrice"></p-sortIcon>
          </th>
          <th pSortableColumn="quantityOpen">
            Qty Open At Idex <p-sortIcon field="quantityOpen"></p-sortIcon>
          </th>
          <th pSortableColumn="asnRemainingQuantity">
            Quantity Remaining <p-sortIcon field="asnRemainingQuantity"></p-sortIcon>
          </th>
          <th pSortableColumn="unitPrice">
            Unit Price <p-sortIcon field="unitPrice"></p-sortIcon>
          </th>

          <th pSortableColumn="paymentTerm">Payment Term <p-sortIcon field="paymentTerm"></p-sortIcon></th>
          <th pSortableColumn="paymentTerm">Payment Term Description <p-sortIcon field="paymentTermsDesc"></p-sortIcon>
          </th>
          <th>Invoice Number</th>
          <th pSortableColumn="buyerNumber">Buyer Number <p-sortIcon field="buyerNumber"></p-sortIcon></th>
          <th>GL Offset</th>
          <th>Currency</th>
          <!-- <th pSortableColumn="exchangeRate">
    Exchange Rate <p-sortIcon field="exchangeRate"></p-sortIcon>
  </th>
  <th pSortableColumn="foreignUnitCost">  
    Foreign Unit Cost <p-sortIcon field="foreignUnitCost"></p-sortIcon>
  </th>
  <th pSortableColumn="foreignExtPrice">
    Foreign Extended Price <p-sortIcon field="foreignExtPrice"></p-sortIcon>
  </th> -->
          <th pSortableColumn="entyDate">Entry Date <p-sortIcon field="entyDate"></p-sortIcon></th>
          <th>Order Line Status</th>
          <th pSortableColumn="dateUpdated">Date Updated <p-sortIcon field="dateUpdated"></p-sortIcon></th>
        </tr>


        <tr>
          <td></td>
          <!-- <td style="padding: 4px;"><input pInputText type="text" [ngModel]="orderCo" (input)="dt2.filterGlobal($event.target.value,
                       'orderCo', 'contains')" placeholder="Keyword" /></td> -->
          <td></td>

          <td>
            <input pInputText class="input" type="text" (input)="dt2.filter($event.target.value,
                      'orderCo',  'customNumber')" placeholder="Keyword" [(ngModel)]="orderCo" />
          </td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'orderNumber',  'customNumber')" [(ngModel)]="orderNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'orderType',  'contains')" [(ngModel)]="orderType" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'orderSuffix',  'contains')" [(ngModel)]="orderSuffix" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'lineNumber',  'customNumber')" [(ngModel)]="lineNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'businessUnit',  'customNumber')" [(ngModel)]="businessUnit" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'addressNumber',  'customNumber')" [(ngModel)]="addressNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'billToName',  'contains')" [(ngModel)]="billToName" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'shipToNumber',  'customNumber')" [(ngModel)]="shipToNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'shipToName',  'contains')" [(ngModel)]="shipToName" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'orderDate',  'customDate')" [(ngModel)]="orderDate" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'requestedDate',  'customDate')" [(ngModel)]="requestedDate" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'promisedDeliveryDate',  'customDate')" [(ngModel)]="scheduledPickDate" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'shortItemNo',  'contains')" [(ngModel)]="shortItemNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'itemNumber',  'contains')" [(ngModel)]="itemNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'itemDesc',  'contains')" [(ngModel)]="description1" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'itemDesc2',  'contains')" [(ngModel)]="description2" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'lineType',  'contains')" [(ngModel)]="lineType" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'nextStatus',  'customNumber')" [(ngModel)]="nextStatus" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'nextStatusDesc',  'contains')" [(ngModel)]="nextStatusDesc" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'lastStatus',  'customNumber')" [(ngModel)]="lastStatus" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'lastStatusDesc',  'contains')" [(ngModel)]="lastStatusDesc" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'valueStream',  'contains')" [(ngModel)]="valueStream" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'valueStreamDesc',  'contains')" [(ngModel)]="valueStreamDesc" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'valueStream1',  'contains')" [(ngModel)]="valueStream1" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'valueStream2',  'contains')" [(ngModel)]="valueStream2" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'um',  'contains')" [(ngModel)]="unitOfMeasure" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'quantityOrdered',  'customNumber')" [(ngModel)]="quantityOrdered" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'quantityOpen',  'customNumber')" [(ngModel)]="quantityOpen" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'extPrice',  'customNumber')" [(ngModel)]="extendedPrice" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'asnRemainingQuantity',  'customNumber')" [(ngModel)]="quantityremaining" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'unitPrice',  'customNumber')" [(ngModel)]="unitPrice" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'paymentTerm',  'contains')" [(ngModel)]="paymentTerm" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'paymentTermsDesc',  'contains')" [(ngModel)]="paymentTermsDesc" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'invoiceNumber',  'contains')" [(ngModel)]="invoiceNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'buyerNumber',  'customNumber')" [(ngModel)]="buyerNumber" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'glOffset',  'contains')" [(ngModel)]="glOffset" /></td>
          <td style="padding: 4px;"><input pInputText type="text" [(ngModel)]="currency" (input)="dt2.filter($event.target.value,
                      'currency',  'contains')" placeholder="Keyword" /></td>
          <!-- <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'exchangeRate',  'contains')" [(ngModel)]="exchangeRate" /></td>
                    <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'foreignUnitCost',  'contains')" [(ngModel)]="foreignUnitCost" /></td>
                    <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'foreignExtPrice',  'contains')" [(ngModel)]="foreignExtendedPrice" /></td> -->
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'entyDate',  'customDate')" [(ngModel)]="entyDate" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'orderLineStatus',  'contains')" [(ngModel)]="orderLineStatus" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword" (input)="dt2.filter($event.target.value,
                      'dateUpdated',  'customDate')" [(ngModel)]="dateUpdated" /></td>

        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-jde let-i="rowIndex">
        <tr class="p-selectable-row" [ngClass]="{'cancelled-row': jde.orderLineStatus === 'Cancelled'}"
          [ngClass]="{'error-row': jde.orderLineStatus === 'QtyError'}">
          <td>{{i+1}}</td>
          <td>
            <input type="checkbox" [(ngModel)]="jde.selected"
              [disabled]="jde.asnRemainingQuantity == 0|| jde.orderLineStatus=='Cancelled'|| jde.orderLineStatus=='QtyError'"
              style="cursor: pointer;">
          </td>
          <!-- <td class="status">
                      <span class="approved" *ngIf="jde.id== 473">
                        Line Closed
                        </span>
                        <span class="inprogress" *ngIf="jde.id !==473">
                          ASN Pending
                          </span> 
                      </td>  -->
          <td>{{jde.orderCo ? jde.orderCo : '-'}}</td>
          <td>{{jde.orderNumber ? jde.orderNumber : '-'}}</td>
          <td>{{jde.orderType ? jde.orderType : '-'}}</td>
          <td>{{jde.orderSuffix ? jde.orderSuffix : '-'}}</td>
          <td>{{jde.lineNumber ? jde.lineNumber : '-'}}</td>
          <td>{{jde.businessUnit ? jde.businessUnit : '-'}}</td>
          <td>{{jde.addressNumber ? jde.addressNumber : '-'}}</td>
          <td>{{jde.billToName ? jde.billToName : '-'}}</td>
          <td>{{jde.shipToNumber ? jde.shipToNumber : '-'}}</td>
          <td>{{jde.shipToName ? jde.shipToName : '-'}}</td>
          <td>{{jde.orderDate ? (jde.orderDate | date: 'dd/MM/yy') : '-'}}</td>
          <td>{{jde.requestedDate ? (jde.requestedDate | date: 'dd/MM/yy') : '-'}}</td>
          <td>{{jde.promisedDeliveryDate ?(jde.promisedDeliveryDate | date: 'dd/MM/yy'): '-'}}</td>
          <td>{{jde.shortItemNo ? jde.shortItemNo : '-'}}</td>
          <td>{{jde.itemNumber ? jde.itemNumber : '-'}}</td>
          <td>{{jde.itemDesc ? jde.itemDesc : '-'}}</td>
          <td>{{jde.itemDesc2 ? jde.itemDesc2 : '-'}}</td>
          <td>{{jde.lineType ? jde.lineType : '-'}}</td>
          <td>{{jde.nextStatus ? jde.nextStatus : '-'}}</td>
          <td>{{jde.nextStatusDesc ? jde.nextStatusDesc : '-'}}</td>
          <td>{{jde.lastStatus ? jde.lastStatus : '-'}}</td>
          <td>{{jde.lastStatusDesc ? jde.lastStatusDesc : '-'}}</td>
          <td>{{jde.valueStream ? jde.valueStream : '-'}}</td>
          <td>{{jde.valueStreamDesc ? jde.valueStreamDesc : '-'}}</td>
          <td>{{jde.valueStream1 ? jde.valueStream1 : '-'}}</td>
          <td>{{jde.valueStream2 ? jde.valueStream2 : '-'}}</td>
          <td>{{jde.um ? jde.um : '-'}}</td>
          <td>{{jde.quantityOrdered ? jde.quantityOrdered : '-'}}</td>
          <td>{{jde.extPrice ? jde.extPrice : '-'}}</td>

          <td>{{jde.quantityOpen ? jde.quantityOpen : '-'}}</td>

          <td>{{jde.asnRemainingQuantity }}</td>
          <td>{{jde.unitPrice ? jde.unitPrice : '-'}}</td>
          <td>{{jde.paymentTerms ? jde.paymentTerms : '-'}}</td>
          <td>{{jde.paymentTermsDesc ? jde.paymentTermsDesc : '-'}}</td>
          <td>{{jde.invoiceNumber ? jde.invoiceNumber : '-'}}</td>
          <td>{{jde.buyerNumber ? jde.buyerNumber : '-'}}</td>
          <td>{{jde.glOffset ? jde.glOffset : '-'}}</td>
          <td>{{jde.currency ? jde.currency : '-'}}</td>
          <!-- <td>{{ isExchangeRateValid(jde.exchangeRate) }}</td>
                    <td>{{jde.foreignUnitCost }}</td>
                    <td>{{jde.foreignExtPrice }}</td> -->
          <td>{{ jde.entyDate ? (jde.entyDate | date: 'dd/MM/yy') : '-' }}</td>
          <td>{{jde.orderLineStatus ? jde.orderLineStatus : '-'}}</td>
          <td>{{jde.dateUpdated ? (jde.dateUpdated | date: 'dd/MM/yy') : '-'}}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">No jdes found.</td>
        </tr>
      </ng-template>
    </p-table>
    <p-table #dt2 [value]="jdedata" *ngIf="userroleName.roleName == 'Supplier'" class="jde_table" dataKey="supplierId"
      [rows]="10" responsiveLayout="scroll" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]"
      [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [filterDelay]="0"
      [globalFilterFields]="['orderLineStatus','orderNumber','shipToName','orderDate','requestedDate','promisedDeliveryDate','lineNumber','itemNumber','itemDesc','itemDesc2','um','quantityOrdered','quantityOpen','asnRemainingQuantity','unitPrice','extPrice','paymentTerms','currency','cancelDate','exchangeRate','foreignUnitCost','foreignExtPrice']">

      <!-- Caption -->
      <ng-template pTemplate="caption">
        <span class="p-input-icon-left d-flex align-items-center">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value,'contains')"
            placeholder="Global Search" [(ngModel)]="filterval" />
          <p-button type="button" class="ml-2" (click)="reset(dt2)" icon="bx bx-reset"></p-button>
          <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onXLSExport()"
            class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom" style="margin-left: 8px;"></button>
          <div class="add-listings-btn"
            *ngIf="userroleName.roleName == 'Supplier' || userroleName.roleName =='Admin' || userroleName.checker1">
            <button type="submit" class="submit_btn" (click)="sendSelectedData()">Generate ASN</button>
          </div>
        </span>
      </ng-template>

      <!-- Header -->
      <ng-template pTemplate="header">
        <!-- <tr>
            <th>S.No.</th>
            <th></th>
            <th>PO Line Status</th>
            <th>PO Number</th>
            <th>Ship to Name</th>
            <th>Order Date</th>
            <th>Requested Date</th>
            <th>Promise Delivery Date</th>
            <th>Line Number</th>
            <th>Item Number</th>
            <th>Description 1</th>
            <th>Description 2</th>
            <th>Unit Of Measure</th>
            <th>Quantity Ordered</th>
            <th>Quantity Open</th>
            <th>Quantity Remaining</th>
            <th>Unit Price</th>
            <th>Extended Price</th>
            <th>Payment Term</th>
            <th>Currency</th>
            <th>Cancel Date</th>
            <th>Exchange Rate</th>
            <th>Foreign Unit Cost</th>
            <th>Foreign Extended Price</th>
        </tr> -->
        <tr>
          <th>S.No.</th>
          <th><input type="checkbox" [(ngModel)]="isAllSelected" (change)="selectAll($event)" style="cursor: pointer;">
          </th>
          <th pSortableColumn="poLineStatus">
            Status <p-sortIcon field="poLineStatus"></p-sortIcon>
          </th>
          <th pSortableColumn="orderNumber">
            PO No <p-sortIcon field="orderNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="shipToName">
            Ship to <p-sortIcon field="shipToName"></p-sortIcon>
          </th>
          <th pSortableColumn="orderDate">
            Order Date <p-sortIcon field="orderDate"></p-sortIcon>
          </th>
          <th pSortableColumn="requestedDate">
            Req Date <p-sortIcon field="requestedDate"></p-sortIcon>
          </th>
          <th pSortableColumn="promisedDeliveryDate">
            Del Date <p-sortIcon field="promisedDeliveryDate"></p-sortIcon>
          </th>
          <th pSortableColumn="lineNumber">
            LN No <p-sortIcon field="lineNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="itemNumber">
            Item <p-sortIcon field="itemNumber"></p-sortIcon>
          </th>
          <th>Description 1</th>
          <th>Description 2</th>
          <th>UOM</th>
          <th pSortableColumn="quantityOrdered">
            Qty Ordered <p-sortIcon field="quantityOrdered"></p-sortIcon>
          </th>
          <th pSortableColumn="extPrice">
            Total Amount <p-sortIcon field="extPrice"></p-sortIcon>
          </th>
          <th pSortableColumn="quantityOpen">
            Qty Open At Idex <p-sortIcon field="quantityOpen"></p-sortIcon>
          </th>
          <th pSortableColumn="asnRemainingQuantity">
            Qty Rem <p-sortIcon field="asnRemainingQuantity"></p-sortIcon>
          </th>
          <th pSortableColumn="unitPrice">
            Unit Price <p-sortIcon field="unitPrice"></p-sortIcon>
          </th>

          <th pSortableColumn="paymentTerm">
            Payment Term <p-sortIcon field="paymentTerm"></p-sortIcon>
          </th>
          <th pSortableColumn="paymentTerm">Payment Term Description<p-sortIcon field="paymentTermsDesc"></p-sortIcon>
          </th>
          <th>Currency</th>
          <th pSortableColumn="cancelDate">
            Cancel Date <p-sortIcon field="cancelDate"></p-sortIcon>
          </th>
          <!-- <th pSortableColumn="exchangeRate">
      Exchange Rate <p-sortIcon field="exchangeRate"></p-sortIcon>
    </th>
    <th pSortableColumn="foreignUnitCost">
      Foreign Unit Cost <p-sortIcon field="foreignUnitCost"></p-sortIcon>
    </th>
    <th pSortableColumn="foreignExtPrice">
      Foreign Extended Price <p-sortIcon field="foreignExtPrice"></p-sortIcon>
    </th> -->
        </tr>
        <tr>

          <td></td> <!-- S.No. no filter -->
          <td></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'orderLineStatus', 'contains')" [(ngModel)]="orderLineStatus" />
          </td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'orderNumber', 'customNumber')" [(ngModel)]="orderNumber" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'shipToName', 'contains')" [(ngModel)]="shipToName" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'orderDate', 'customDate')" [(ngModel)]="orderDate" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'requestedDate', 'customDate')" [(ngModel)]="requestedDate" />
          </td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'promisedDeliveryDate', 'customDate')"
              [(ngModel)]="scheduledPickDate" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'lineNumber', 'customNumber')" [(ngModel)]="lineNumber" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'itemNumber', 'customNumber')" [(ngModel)]="itemNumber" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'itemDesc', 'contains')" [(ngModel)]="description1" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'itemDesc2', 'contains')" [(ngModel)]="description2" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'um', 'contains')" [(ngModel)]="unitOfMeasure" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'quantityOrdered', 'customNumber')"
              [(ngModel)]="quantityOrdered" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'extPrice', 'customNumber')" [(ngModel)]="extendedPrice" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'quantityOpen', 'customNumber')" [(ngModel)]="quantityOpen" />
          </td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'asnRemainingQuantity', 'customNumber')"
              [(ngModel)]="quantityremaining" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'unitPrice', 'customNumber')" [(ngModel)]="unitPrice" /></td>


          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'paymentTerms', 'contains')" [(ngModel)]="paymentTerm" /></td>
          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'paymentTermsDesc', 'contains')"
              [(ngModel)]="paymentTermsDesc" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'currency', 'contains')" [(ngModel)]="currency" /></td>

          <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
              (input)="dt2.filter($event.target.value, 'cancelDate', 'customDate')" [(ngModel)]="cancelDate" /></td>

          <!-- <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
        (input)="dt2.filter($event.target.value, 'exchangeRate', 'customDate')" [(ngModel)]="exchangeRate" /></td>

    <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
        (input)="dt2.filter($event.target.value, 'foreignUnitCost', 'customNumber')" [(ngModel)]="foreignUnitCost" /></td>

    <td style="padding: 4px;"><input pInputText type="text" placeholder="Keyword"
        (input)="dt2.filter($event.target.value, 'foreignExtPrice', 'customNumber')" [(ngModel)]="foreignExtendedPrice" /></td> -->
        </tr>

      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-jde let-i="rowIndex">
        <tr [ngClass]="{'cancelled-row': jde.orderLineStatus === 'Cancelled'}"
          [ngClass]="{'error-row': jde.orderLineStatus === 'QtyError'}">
          <td>{{ i + 1 }}</td>
          <td>
            <input type="checkbox" [(ngModel)]="jde.selected"
              [disabled]="jde.asnRemainingQuantity == 0|| jde.orderLineStatus=='Cancelled' || jde.orderLineStatus=='QtyError'"
              style="cursor: pointer;">
          </td>
          <td>{{ jde.orderLineStatus || '-' }}</td>
          <td>{{ jde.orderNumber || '-' }}</td>
          <td>{{ jde.shipToName || '-' }}</td>
          <td>{{ jde.orderDate ? (jde.orderDate | date:'dd/MM/yy') : '-' }}</td>
          <td>{{ jde.requestedDate ? (jde.requestedDate | date:'dd/MM/yy') : '-' }}</td>
          <td>{{ jde.promisedDeliveryDate ? (jde.promisedDeliveryDate | date:'dd/MM/yy') : '-' }}</td>
          <td>{{ jde.lineNumber || '-' }}</td>
          <td>{{ jde.itemNumber || '-' }}</td>
          <td>{{ jde.itemDesc || '-' }}</td>
          <td>{{ jde.itemDesc2 || '-' }}</td>
          <td>{{ jde.um || '-' }}</td>
          <td>{{ jde.quantityOrdered || '-' }}</td>
          <td>{{ jde.extPrice || '-' }}</td>
          <td>{{ jde.quantityOpen || '-' }}</td>
          <td>{{ jde.asnRemainingQuantity || '-' }}</td>
          <td>{{ jde.unitPrice || '-' }}</td>
          <td>{{ jde.paymentTerms || '-' }}</td>
          <td>{{jde.paymentTermsDesc|| '-'}}</td>
          <td>{{ jde.currency || '-' }}</td>
          <!-- <td>{{ jde?.cancelDate ? (jde?.cancelDate | date:'MM/dd/yyyy') : '-' }}</td> -->
          <!-- <td>{{ jde.cancelDate ? (jde.cancelDate.| date:'MM/dd/yyyy') : '-' }}</td> -->
          <td>{{ jde.cancelDate ? (jde.cancelDate | date:'dd/MM/yy') : '-' }}</td>
          <!-- <td>{{isExchangeRateValid(jde.exchangeRate) }}</td>
            <td>{{ jde.foreignUnitCost  }}</td>
            <td>{{ jde.foreignExtPrice }}</td> -->
        </tr>
      </ng-template>

      <!-- Empty Message -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="23" class="text-center">No records found.</td>
        </tr>
      </ng-template>

    </p-table>

    <div class="flex-grow-1"></div>
  </div>
  <!-- End -->

  <app-copyrights></app-copyrights>

</div>